<love-it-modal-header
  (close)="modal.dismiss()"
  title="Berichtszusammenfassung"></love-it-modal-header>
@for (report of data?.reports; let i = $index; track report.id) {
  <div class="modal-body text-end status-header">
    <div>Erstellt am {{ report.createdDate | date: "dd.MM.yyy HH:mm" : undefined : "de-AT" }}</div>
    <div>Zuletzt geändert am {{ getLastUpdatedDate(report) | date: "dd.MM.yyy HH:mm" : undefined : "de-AT" }}</div>
  </div>
  <div class="modal-body">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <label for="office">Bericht für</label>&nbsp;
            <span id="office">{{ report.office }}</span>
          </div>
          @if (report.type === ReportType.Wohnung) {
            <div class="col-sm-6">
              <label for="housing">Wohnung</label>&nbsp;
              <span id="housing">{{ report.housing }}</span>
            </div>
          } @else {
            <div class="col-sm-6">
              <label for="subject">Betreff</label>&nbsp;
              <span id="subject">{{ report.subject }}</span>
            </div>
          }
          <div class="col-sm-6">
            <label for="mainEmployee">Verfasser:in</label>&nbsp;
            <span id="mainEmployee">{{ report.mainEmployee }}</span>
          </div>
          <div class="col-sm-6">
            <label for="otherEmployees">Weitere anwesende Betreuer:innen</label>&nbsp;
            <span id="otherEmployees">{{ report.otherEmployees.join(", ") }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Berichtseinträge</h4>
      </div>
      <div class="card-body">
        @for (reportEntry of report.reportEntries; let i = $index; track reportEntry.id) {
          <div
            class="row mb-2"
            [ngClass]="{ 'border-top': i > 0, 'pt-2': i > 0 }">
            <div class="col-sm-1">
              <span>{{ reportEntry.updatedDate | date: "dd.MM.yyy HH:mm" : undefined : "de-AT" }}</span>
            </div>
            <div class="col-sm-5">
              <label [for]="'description' + i"> Beschreibung </label><br />
              <span
                [id]="'description' + i"
                [innerHTML]="reportEntry.details"></span>
            </div>
            <div class="col-sm-4">
              <div class="mb-2">
                <label [for]="'affectedClients' + i">Relevant für Klient:innen</label>&nbsp;
                <span [id]="'affectedClients' + i">{{ reportEntry.affectedClients.join(", ") }}</span>
              </div>
              <div>
                <label [for]="'reportEntryCategory' + i">Kategorie</label>&nbsp;
                <span [id]="'reportEntryCategory' + i">{{ reportEntry.category }}</span>
              </div>
            </div>
            <div class="col-sm-1">
              @if (reportEntry.isIncident && reportEntry.isBlueLightIncident) {
                <div
                  class="alert alert-danger"
                  role="alert">
                  Blaulicht-Vorfall!
                </div>
              } @else if (reportEntry.isIncident) {
                <div
                  class="alert alert-warning"
                  role="alert">
                  Vorfall!
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
<div class="modal-footer">
  <button
    rippleEffect
    type="button"
    class="btn-mobile-group btn-primary"
    (click)="modal.dismiss()">
    Schließen
  </button>
</div>
